const ApiAttributesKeys = {
  // Edition-stable flat keys emitted by the backend for all CFA1 years (see services/CFA/dashboard.js).
  performanceGraphUserAttemptedCountKey: 'userAttemptCount',
  performanceGraphUserAnsweredCountKey: 'userAnswerCount',
  chapterNameKey: 'chapter_name',
  attemptedCountKey: 'attempted_count',
  answeredCountKey: 'answered_count',
  questionTableNameKey: 'questions',
  questionStatsTableNameKey: 'cfa1_2024_question_stats',
  notesTableNameKey: 'cfa1_2025_notes',
  notesStatsTableNameKey: 'cfa1_2024_notes_stats',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Dashboard/ApiAttributesKays.js